export default __webpack_public_path__ + "static/media/img-gtl-abp.c2066dfd.png";